import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CertificadoService } from 'src/app/services/certificado.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { DomSanitizer, Meta, SafeResourceUrl } from '@angular/platform-browser';
import { Certificado } from 'src/app/models/certificado';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {

  @ViewChild("Resultado") resultado: ElementRef;

  ies: any;
  logo: string;
  id: string;
  isLoading: boolean = false;
  captcha: string;
  certificacaoForm: UntypedFormGroup

  certificado: Certificado;
  pdf: SafeResourceUrl;
  imagem: SafeResourceUrl;

  exibePDF: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private certificadoService: CertificadoService,
    private form: UntypedFormBuilder,
    private toastr: ToastrService,
    private location: Location,
    private meta: Meta,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    // Define a IES
    if ('ies' in sessionStorage) {
      this.ies = JSON.parse(sessionStorage.getItem('ies'));
    }

    // Se existir o código via url, salva para executar a pesquisa
    this.route.paramMap.subscribe(paramMap => {
      this.id = paramMap.get('id');

      if (this.id) {
        this.busca(this.id);
      }
    });

    // Inicializa o form
    this.certificacaoForm = this.form.group({
      codigo: new UntypedFormControl('', Validators.required),
      captcha: new UntypedFormControl('', Validators.required)
    });

    // Captcha
    this.generateCaptcha();
  }

  busca(codigo: string) {
    this.isLoading = true;

    this.certificadoService.getCertificado(codigo).subscribe(response => {
      this.isLoading = false;

      this.certificado = response;
      this.pdf = response.url;
      this.imagem = response.urlFrente;

      // Adiciona o certificado à url
      this.location.replaceState(`./${codigo}`);

      // Teste meta tags
      this.meta.updateTag({ property: 'og:title', content: 'Certificação ' + this.ies.name });
      this.meta.updateTag({ property: 'og:description', content: `Certificação é na ${this.ies.name}` });
      this.meta.updateTag({ property: 'og:image', content: this.certificado.urlFrente });
      this.meta.updateTag({ property: 'og:url', content: this.certificado.urlFrente });

    }, error => {
      this.isLoading = false;
      console.log('Erro: ', error);

      if (error.status === 404) {
        this.toastr.warning('Certificado não encontrado.');
      } else {
        this.toastr.error('Erro ao processar a requisição.');
      }
    });
  }

  generateCaptcha() {
    let a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      n = "0123456789",
      cap_size = 4, // Captcha length
      captchaTemp = "";

    function randomizer(x: number) {
      return Math.floor(Math.random() * x);
    };

    while (cap_size--) {
      // if 0 add a random alphabetic character
      if (randomizer(2) === 0) {
        captchaTemp += a[randomizer(a.length)];
      } else {
        // if 1 add a random numeric character
        captchaTemp += n[randomizer(n.length)];
      }
    }

    this.captcha = captchaTemp;
  }

  exibirPDF() {
    this.exibePDF = true;

    // Scroll para resultado
    setTimeout(() => {
      window.scroll({
        top: this.resultado.nativeElement.offsetTop - 80, behavior: 'smooth'
      });
    }, 250);
  }

}
